import { createFileRoute } from '@tanstack/react-router';

import { supplyAppsRouteSearchSchema } from '../features/supply/apps/appsRouteSearch';
import { AppsTable } from '../features/supply/apps/components/AppsTable/AppsTable';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/apps')({
  validateSearch: supplyAppsRouteSearchSchema,
  component: PublisherAppsRoute,
});

function PublisherAppsRoute() {
  const { publisherId } = Route.useParams();
  return <AppsTable publisherId={publisherId} />;
}
